// Generated by Framer (f7d95e4)
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addFonts, addPropertyControls, ControlType, cx, useActiveVariantCallback, useComponentViewport, useLocaleInfo, useVariantState, withCSS } from "framer";
import { LayoutGroup, motion, MotionConfigContext } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
const cycleOrder = ["Q6IWiB4Vd", "AKDNPwvdD"];
const serializationHash = "framer-bw8gE";
const variantClassNames = {
  AKDNPwvdD: "framer-v-r4p5b1",
  Q6IWiB4Vd: "framer-v-1vwykab"
};
function addPropertyOverrides(overrides, ...variants) {
  const nextOverrides = {};
  variants?.forEach(variant => variant && Object.assign(nextOverrides, overrides[variant]));
  return nextOverrides;
}
const transition1 = {
  damping: 60,
  delay: 0,
  mass: 1,
  stiffness: 500,
  type: "spring"
};
const Transition = ({
  value,
  children
}) => {
  const config = React.useContext(MotionConfigContext);
  const transition = value ?? config.transition;
  const contextValue = React.useMemo(() => ({
    ...config,
    transition
  }), [JSON.stringify(transition)]);
  return /*#__PURE__*/_jsx(MotionConfigContext.Provider, {
    value: contextValue,
    children: children
  });
};
const Variants = motion.create(React.Fragment);
const humanReadableVariantMap = {
  Close: "AKDNPwvdD",
  Default: "Q6IWiB4Vd"
};
const getProps = ({
  height,
  id,
  tap,
  width,
  ...props
}) => {
  return {
    ...props,
    mNnEtKoz7: tap ?? props.mNnEtKoz7,
    variant: humanReadableVariantMap[props.variant] ?? props.variant ?? "Q6IWiB4Vd"
  };
};
const createLayoutDependency = (props, variants) => {
  if (props.layoutDependency) return variants.join("-") + props.layoutDependency;
  return variants.join("-");
};
const Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
  const fallbackRef = useRef(null);
  const refBinding = ref ?? fallbackRef;
  const defaultLayoutId = React.useId();
  const {
    activeLocale,
    setLocale
  } = useLocaleInfo();
  const componentViewport = useComponentViewport();
  const {
    style,
    className,
    layoutId,
    variant,
    mNnEtKoz7,
    ...restProps
  } = getProps(props);
  const {
    baseVariant,
    classNames,
    clearLoadingGesture,
    gestureHandlers,
    gestureVariant,
    isLoading,
    setGestureState,
    setVariant,
    variants
  } = useVariantState({
    cycleOrder,
    defaultVariant: "Q6IWiB4Vd",
    ref: refBinding,
    variant,
    variantClassNames
  });
  const layoutDependency = createLayoutDependency(props, variants);
  const {
    activeVariantCallback,
    delay
  } = useActiveVariantCallback(baseVariant);
  const onTap1j5npcq = activeVariantCallback(async (...args) => {
    setGestureState({
      isPressed: false
    });
    if (mNnEtKoz7) {
      const res = await mNnEtKoz7(...args);
      if (res === false) return false;
    }
  });
  const sharedStyleClassNames = [];
  const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
  return /*#__PURE__*/_jsx(LayoutGroup, {
    id: layoutId ?? defaultLayoutId,
    children: /*#__PURE__*/_jsx(Variants, {
      animate: variants,
      initial: false,
      children: /*#__PURE__*/_jsx(Transition, {
        value: transition1,
        children: /*#__PURE__*/_jsxs(motion.div, {
          ...restProps,
          ...gestureHandlers,
          className: cx(scopingClassNames, "framer-1vwykab", className, classNames),
          "data-framer-name": "Default",
          "data-highlight": true,
          layoutDependency: layoutDependency,
          layoutId: "Q6IWiB4Vd",
          onTap: onTap1j5npcq,
          ref: refBinding,
          style: {
            ...style
          },
          ...addPropertyOverrides({
            AKDNPwvdD: {
              "data-framer-name": "Close"
            }
          }, baseVariant, gestureVariant),
          children: [/*#__PURE__*/_jsx(motion.div, {
            className: "framer-1eskn2z",
            "data-framer-name": "Line 1",
            layoutDependency: layoutDependency,
            layoutId: "mEYCEbisA",
            style: {
              backgroundColor: "var(--token-9c4db272-3e6f-4bdb-870d-13efb9df1386, rgb(255, 255, 255))",
              borderBottomLeftRadius: 7,
              borderBottomRightRadius: 7,
              borderTopLeftRadius: 7,
              borderTopRightRadius: 7,
              rotate: 0
            },
            variants: {
              AKDNPwvdD: {
                rotate: 45
              }
            }
          }), /*#__PURE__*/_jsx(motion.div, {
            className: "framer-17n106j",
            "data-framer-name": "Line 2",
            layoutDependency: layoutDependency,
            layoutId: "jzfoZbkDy",
            style: {
              backgroundColor: "var(--token-9c4db272-3e6f-4bdb-870d-13efb9df1386, rgb(255, 255, 255))",
              borderBottomLeftRadius: 7,
              borderBottomRightRadius: 7,
              borderTopLeftRadius: 7,
              borderTopRightRadius: 7,
              opacity: 1
            },
            variants: {
              AKDNPwvdD: {
                opacity: 0
              }
            }
          }), /*#__PURE__*/_jsx(motion.div, {
            className: "framer-1vw4hxs",
            "data-framer-name": "Line 3",
            layoutDependency: layoutDependency,
            layoutId: "SxOJlLYy1",
            style: {
              backgroundColor: "var(--token-9c4db272-3e6f-4bdb-870d-13efb9df1386, rgb(255, 255, 255))",
              borderBottomLeftRadius: 7,
              borderBottomRightRadius: 7,
              borderTopLeftRadius: 7,
              borderTopRightRadius: 7,
              rotate: 0
            },
            variants: {
              AKDNPwvdD: {
                rotate: -45
              }
            }
          })]
        })
      })
    })
  });
});
const css = ["@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }", ".framer-bw8gE.framer-gxba39, .framer-bw8gE .framer-gxba39 { display: block; }", ".framer-bw8gE.framer-1vwykab { cursor: pointer; height: 31px; overflow: hidden; position: relative; width: 31px; }", ".framer-bw8gE .framer-1eskn2z { flex: none; height: 2px; left: 0px; overflow: hidden; position: absolute; right: 0px; top: 6px; will-change: var(--framer-will-change-override, transform); }", ".framer-bw8gE .framer-17n106j { flex: none; height: 2px; left: 0px; overflow: hidden; position: absolute; right: 0px; top: calc(48.38709677419357% - 2px / 2); will-change: var(--framer-will-change-override, transform); }", ".framer-bw8gE .framer-1vw4hxs { bottom: 6px; flex: none; height: 2px; left: 0px; overflow: hidden; position: absolute; right: 0px; will-change: var(--framer-will-change-override, transform); }", ".framer-bw8gE.framer-v-r4p5b1 .framer-1eskn2z { left: calc(48.38709677419357% - 27px / 2); right: unset; top: calc(51.61290322580647% - 2px / 2); width: 27px; }", ".framer-bw8gE.framer-v-r4p5b1 .framer-17n106j { right: unset; top: calc(51.61290322580647% - 2px / 2); width: 1px; }", ".framer-bw8gE.framer-v-r4p5b1 .framer-1vw4hxs { bottom: unset; left: calc(48.38709677419357% - 27px / 2); right: unset; top: calc(51.61290322580647% - 2px / 2); width: 27px; }"];
/**
 * This is a generated Framer component.
 * @framerIntrinsicHeight 31
 * @framerIntrinsicWidth 31
 * @framerCanvasComponentVariantDetails {"propertyName":"variant","data":{"default":{"layout":["fixed","fixed"]},"AKDNPwvdD":{"layout":["fixed","fixed"]}}}
 * @framerVariables {"mNnEtKoz7":"tap"}
 * @framerImmutableVariables true
 * @framerDisplayContentsDiv false
 * @framerComponentViewportWidth true
 */
const FramerBMejH6OL8 = withCSS(Component, css, "framer-bw8gE");
export default FramerBMejH6OL8;
FramerBMejH6OL8.displayName = "Navigation/Hamburger";
FramerBMejH6OL8.defaultProps = {
  height: 31,
  width: 31
};
addPropertyControls(FramerBMejH6OL8, {
  variant: {
    options: ["Q6IWiB4Vd", "AKDNPwvdD"],
    optionTitles: ["Default", "Close"],
    title: "Variant",
    type: ControlType.Enum
  },
  mNnEtKoz7: {
    title: "Tap",
    type: ControlType.EventHandler
  }
});
addFonts(FramerBMejH6OL8, [{
  explicitInter: true,
  fonts: []
}], {
  supportsExplicitInterCodegen: true
});
export const __FramerMetadata__ = {
  exports: {
    Props: {
      type: "tsType",
      annotations: {
        framerContractVersion: "1"
      }
    },
    default: {
      type: "reactComponent",
      name: "FramerBMejH6OL8",
      slots: [],
      annotations: {
        framerVariables: '{"mNnEtKoz7":"tap"}',
        framerContractVersion: "1",
        framerCanvasComponentVariantDetails: '{"propertyName":"variant","data":{"default":{"layout":["fixed","fixed"]},"AKDNPwvdD":{"layout":["fixed","fixed"]}}}',
        framerDisplayContentsDiv: "false",
        framerIntrinsicWidth: "31",
        framerImmutableVariables: "true",
        framerComponentViewportWidth: "true",
        framerIntrinsicHeight: "31"
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};
//# sourceMappingURL=./BMejH6OL8.map